import { useCitOriginClient } from '@hub/common-components/src/CitOriginClientProvider';
import CatalogItIcon from './SVG/CatalogItIcon';
import { CitOrigin } from '@hub/common/src/types/cit-public-api';

function SkeletonNavBar() {
  return (
    <nav className='navbar fixed top-0 left-0 right-0 bg-gray-800 text-white p-4 w-full z-50'>
      <div className='ml-12 flex items-center space-x-2'>
        <CatalogItIcon size={40} className='hidden md:block' />
        <span className='hidden md:block text-white text-[28px] font-bold flex items-center'>
          HUB
        </span>
      </div>
    </nav>
  );
}

export default function LoadingSkeleton() {
  const citOrigin = useCitOriginClient();

  return (
    <div>
      {citOrigin === CitOrigin.HUB ? <SkeletonNavBar /> : null}
      {/* Loading Spinner */}
      <div className='flex items-center justify-center min-h-screen'>
        <div className='w-48 h-48 border-8 border-gray-300 border-t-blue-600 rounded-full animate-spin'></div>
      </div>
    </div>
  );
}
